import React from 'react';
import { SmoUlClosingStatus } from '../services/api';
import { formatDateShort } from '../utils/table';

export function closingStatusLabel(status: SmoUlClosingStatus): string {
  if (status === 'closed') return 'Закрыто';
  if (status === 'waiting') return 'Ожидает';
  if (status === 'partial') return 'Частично';
  if (status === 'open') return 'Не закрыто';
  return '—';
}

export function ClosingStatusIcon({
  status,
  closingDate,
}: {
  status: SmoUlClosingStatus;
  closingDate?: string | null;
}): React.ReactElement {
  const dateTitle = closingDate ? formatDateShort(closingDate) : undefined;

  if (status === 'na') {
    return <span className="smo-ul-closing-status smo-ul-closing-status--na">—</span>;
  }
  if (status === 'closed') {
    return (
      <span
        className="smo-ul-closing-status smo-ul-closing-status--closed"
        aria-label={dateTitle ? `Закрыто ${dateTitle}` : 'Закрыто'}
        title={dateTitle ?? 'Закрыто'}
      >
        <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden>
          <circle cx="8" cy="8" r="7" fill="#1f9d55" stroke="#167a40" strokeWidth="1" />
          <path
            d="M4.6 8.2 7 10.6l4.4-5.2"
            fill="none"
            stroke="#fff"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    );
  }
  if (status === 'partial') {
    return (
      <span
        className="smo-ul-closing-status smo-ul-closing-status--partial"
        aria-label={dateTitle ? `Частично закрыто ${dateTitle}` : 'Частично закрыто'}
        title={dateTitle ? `Частично: ${dateTitle}` : 'Частично закрыто'}
      >
        <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden>
          <circle cx="8" cy="8" r="6.5" fill="none" stroke="#8a94a6" strokeWidth="1.5" />
          <path d="M8 1.5 A6.5 6.5 0 0 1 8 14.5 Z" fill="#1f9d55" />
        </svg>
      </span>
    );
  }
  if (status === 'waiting') {
    return (
      <span
        className="smo-ul-closing-status smo-ul-closing-status--waiting"
        aria-label="Ожидает подтверждения РП"
        title="Ожидает подтверждения РП"
      >
        ?
      </span>
    );
  }
  return (
    <span className="smo-ul-closing-status smo-ul-closing-status--open" aria-label="Не закрыто" title="Не закрыто">
      <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden>
        <circle cx="8" cy="8" r="6.5" fill="none" stroke="#8a94a6" strokeWidth="1.5" />
      </svg>
    </span>
  );
}
